import { apiHosts } from "@/api/constants/apiHosts";
import type { ApplicationSetting } from "@/settings/applicationSetting";
import type { ToastOptionsError, ToastOptionsSuccess } from "@modernary/mui/components/toasts";
import { apiService, type Paging, type PagingApiAndNotifierConfig } from "@modernary/mui/utils/api";

const URL = "application-settings";
const api = apiService<ApplicationSetting>(apiHosts.AQMS, { baseURL: import.meta.env.VITE_AQMS_API_BASE_URL });

const getApplicationSettings = (config: PagingApiAndNotifierConfig = {}) => {
  const successToastCb = (options: ToastOptionsSuccess) => {
    options.hide = true;
    config?.successToastCb?.(options);
  };
  const errorToastCb = (options: ToastOptionsError) => {
    options.fetched = "Application Settings";
    config?.errorToastCb?.(options);
  };

  return api.getPaged<Paging<ApplicationSetting>>(URL, { successToastCb, errorToastCb });
};

export { getApplicationSettings };
